(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      // De IntersectionObserver vuurde hier maar een enkele keer en leverde soms
      // leeg vlak op, of vuurde helemaal niet voordat er gescrold werd. Dan
      // bleef headerBounds leeg en deed onScroll niets: elke vergelijking met
      // undefined is onwaar, dus de header bleef gewoon meescrollen. Zelf meten
      // is hier betrouwbaarder, en geeft meteen de juiste ondergrens zodat de
      // header pas reageert nadat je hem voorbij bent.
      this.setHeaderBounds();
      window.addEventListener('resize', this.setHeaderBounds.bind(this));
      window.addEventListener('load', this.setHeaderBounds.bind(this));
    }

    setHeaderBounds() {
      const rect = this.header.getBoundingClientRect();
      const top = rect.top + (window.pageYOffset || document.documentElement.scrollTop);
      this.headerBounds = { top: top, bottom: top + rect.height };
      this.bewaarHoogte();
    }

    // De vastgezette balk is lager dan de gewone header (minder ruimte boven en
    // onder het logo). Hij staat in de flow, dus op het moment dat hij
    // vastklikt kromp de pagina met dat verschil en sprong alles omhoog.
    // We onthouden de gewone hoogte en vullen het verschil aan met een marge.
    bewaarHoogte() {
      if (this.header.classList.contains('shopify-section-header-sticky')) return;
      this.gewoneHoogte = this.header.offsetHeight;
      this.vulAan();
    }

    // Bewust niet in een requestAnimationFrame: die staat stil zolang het
    // tabblad niet zichtbaar is, en dan blijft de marge achterwege. De klasse
    // is hier al gezet, dus offsetHeight geeft meteen de nieuwe hoogte.
    vulAan() {
      if (!this.gewoneHoogte) return;
      const vast = this.header.classList.contains('shopify-section-header-sticky');
      const verschil = vast ? this.gewoneHoogte - this.header.offsetHeight : 0;
      this.header.style.marginBottom = verschil > 0 ? verschil + 'px' : '';
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.vulAan();
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.vulAan();
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.vulAan();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
